import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api, fmtZAR } from '../lib/api';
import { Users, Wallet, AlertCircle, CheckCircle, Clock, GraduationCap, BookOpen, TrendingDown } from 'lucide-react';

const Metric = ({ icon: Icon, label, value, sub, testid }) => (
  <div className="bg-white rounded-2xl border border-black/5 p-5" data-testid={testid}>
    <div className="w-10 h-10 rounded-xl bg-[#1F6F4A]/10 flex items-center justify-center mb-4">
      <Icon size={18} className="text-[#1F6F4A]"/>
    </div>
    <p className="text-xs font-mono tracking-wider text-[#4B5563] uppercase">{label}</p>
    <p className="text-2xl md:text-3xl font-black text-[#1B2A41] mt-1" style={{ fontFamily: 'Outfit' }}>{value}</p>
    {sub && <p className="text-xs text-[#4B5563] mt-1">{sub}</p>}
  </div>
);

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/admin/dashboard').then((r) => setData(r.data)); }, []);
  const m = data?.metrics;

  return (
    <AdminShell title={`Dashboard · ${data?.academic_year ?? ''}`}>
      {!m ? (
        <p className="text-sm text-[#4B5563]">Loading metrics…</p>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="dashboard-metrics">
            <Metric icon={Users} label="Total learners" value={m.total_learners} sub="All time" testid="metric-total-learners"/>
            <Metric icon={GraduationCap} label="Active learners" value={m.active_learners} sub="With active enrolments" testid="metric-active-learners"/>
            <Metric icon={BookOpen} label="CAPS / IEB" value={`${m.caps_learners} / ${m.ieb_learners}`} sub="Learner split" testid="metric-caps-ieb"/>
            <Metric icon={BookOpen} label="Active subscriptions" value={m.active_subscriptions} sub="Subject enrolments" testid="metric-subscriptions"/>
            <Metric icon={Wallet} label="Expected monthly" value={fmtZAR(m.expected_monthly_revenue_cents)} sub="If all subscriptions bill" testid="metric-expected"/>
            <Metric icon={CheckCircle} label="Verified collections" value={fmtZAR(m.verified_collections_cents)} sub="Lifetime verified" testid="metric-verified"/>
            <Metric icon={AlertCircle} label="Outstanding" value={fmtZAR(m.outstanding_cents)} sub="Across all invoices" testid="metric-outstanding"/>
            <Metric icon={Clock} label="Pending registrations" value={m.pending_registrations} sub="Awaiting payment" testid="metric-pending-regs"/>
            <Metric icon={GraduationCap} label="Pending onboarding" value={m.pending_onboarding} sub="Awaiting classroom" testid="metric-pending-onboarding"/>
            <Metric icon={TrendingDown} label="Cancellations" value={m.monthly_cancellations} sub="This academic year" testid="metric-cancellations"/>
          </div>

          <p className="text-xs text-[#4B5563] mt-6 max-w-2xl">
            Metrics distinguish <strong>unique learners</strong> (one per child), <strong>subject subscriptions</strong>, <strong>registrations</strong>, <strong>billed revenue</strong> and <strong>verified collections</strong> — these are not interchangeable.
          </p>
        </>
      )}
    </AdminShell>
  );
};

export default AdminDashboard;
